<script setup lang="ts">
import { Badge } from "~/components/clarity-ui/Badge";
import useMyBritaUser from "~/composables/useMyBritaUser";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

export interface MyBritaButtonProps {
  /** A string representing the ARIA label for the element. */
  ariaLabel?: string;
}

const { ariaLabel } = defineProps<MyBritaButtonProps>();

const { $msal } = useNuxtApp();
const { isMyBritaLoggedIn } = useMyBritaUser();
const { marketSetupLinks } = useMarketSetup();
const { push } = useRouter();

const onClick = async () => {
  if (isMyBritaLoggedIn.value) {
    await push(marketSetupLinks.value?.myBritaOverviewPage);
  } else {
    if (marketSetupLinks?.value?.myBritaRegisterPage) {
      await push(marketSetupLinks.value?.myBritaRegisterPage);
    } else {
      await $msal.signInSignUp();
    }
  }
};
</script>

<template>
  <button
    class="relative h-11 w-11 rounded-md p-2 hover:text-deep-blue"
    :aria-label="ariaLabel"
    @click="onClick"
  >
    <SvgIcon class="absolute left-[calc(50%-12px)] top-[calc(50%-12px)] h-6 w-6" name="User" />
    <ClientOnly>
      <Badge v-if="isMyBritaLoggedIn" class="absolute bottom-1 right-0" />
    </ClientOnly>
  </button>
</template>
